import React from "react";

export function FormPartSection (props) {
    let {formPart} = props

    return (
        <div className={'form-group'}>
            <div>
                <div className={'section'} dangerouslySetInnerHTML={{__html: formPart.content}} />
            </div>
        </div>
    )
}